import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Products from "../pages/products/page";
import HyreachClipper from "../pages/hyreach-clipper/page";
import TreePuller from "../pages/tree-puller/page";
import AddAGrapple from "../pages/add-a-grapple/page";
import GrappleRake from "../pages/grapple-rake/page";
import MiniClip from "../pages/mini-clip/page";
import ExtremeDutyPage from "../pages/extreme-duty/page";
import TeleclipperPage from "../pages/teleclipper/page";
import ClampitPage from "../pages/clampit/page";
import Eliminator537 from "../pages/tree-puller/537-eliminator/page";
import ExtremeDuty527 from "../pages/tree-puller/527-extreme-duty/page";
import Eliminator535 from "../pages/tree-puller/535-eliminator/page";
import AddAGrappleMini from '../pages/add-a-grapple/mini/page';
import AddAGrappleSmall from '../pages/add-a-grapple/small/page';
import AddAGrappleSingle from '../pages/add-a-grapple/single/page';
import DoublePage from '../pages/add-a-grapple/double/page';
import FrontLoaderPage from '../pages/add-a-grapple/front-loader/page';
import SkidSteerPage from '../pages/add-a-grapple/skid-steer/page';
import HelpFaqsPage from '../pages/help-faqs/page';
import AboutUsPage from '../pages/about-us/page';

const GrappleRakePage = lazy(() => import('../pages/grapple-rake/page'));
const BigMouth327Page = lazy(() => import('../pages/grapple-rake/big-mouth-327/page'));
const HeavyDuty444Page = lazy(() => import('../pages/grapple-rake/heavy-duty-444/page'));
const Contractor433Page = lazy(() => import('../pages/grapple-rake/contractor-433/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/products",
    element: <Products />,
  },
  {
    path: "/hyreach-clipper",
    element: <HyreachClipper />,
  },
  {
    path: "/tree-puller",
    element: <TreePuller />,
  },
  {
    path: "/add-a-grapple",
    element: <AddAGrapple />,
  },
  {
    path: '/add-a-grapple/mini',
    element: <AddAGrappleMini />,
  },
  {
    path: '/add-a-grapple/small',
    element: <AddAGrappleSmall />,
  },
  {
    path: '/add-a-grapple/single',
    element: <AddAGrappleSingle />,
  },
  {
    path: '/add-a-grapple/double',
    element: <DoublePage />,
  },
  {
    path: '/add-a-grapple/front-loader',
    element: <FrontLoaderPage />,
  },
  {
    path: '/add-a-grapple/skid-steer',
    element: <SkidSteerPage />,
  },
  {
    path: "/grapple-rake",
    element: <GrappleRakePage />,
  },
  {
    path: '/grapple-rake/big-mouth-327',
    element: <BigMouth327Page />,
  },
  {
    path: '/grapple-rake/heavy-duty-444',
    element: <HeavyDuty444Page />,
  },
  {
    path: '/grapple-rake/contractor-433',
    element: <Contractor433Page />,
  },
  {
    path: "/mini-clip",
    element: <MiniClip />,
  },
  {
    path: "/extreme-duty",
    element: <ExtremeDutyPage />,
  },
  {
    path: "/teleclipper",
    element: <TeleclipperPage />,
  },
  {
    path: "/clampit",
    element: <ClampitPage />,
  },
  {
    path: '/tree-puller/537-eliminator',
    element: <Eliminator537 />,
  },
  {
    path: '/tree-puller/527-extreme-duty',
    element: <ExtremeDuty527 />,
  },
  {
    path: '/tree-puller/535-eliminator',
    element: <Eliminator535 />,
  },
  {
    path: '/help-faqs',
    element: <HelpFaqsPage />,
  },
  {
    path: '/about-us',
    element: <AboutUsPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
